class Extension {
  name; 
  
  constructor() {
    this.name = 'Extension';
  }

  init() {

  }

  get logPrefix() {
    return `\x1b[30;46;1m[Extension/${this.name.match(/[A-Z]/g).join("-")}]`;
  }
}

export default Extension;